import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import {
  Box,
  Grid,
  MenuItem,
  TextField,
  Typography,
  useTheme,
  Autocomplete,
  Checkbox,
} from "@mui/material";
import styles from "../PostSearch/PostRequirement.module.css";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { customTextColor } from "../../utils/const";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { updatePostRequirement } from "../../redux/post-requirement/postRequirementSlice";
import { useLocation, useNavigate } from "react-router-dom";
import {
  mode_of_interview,
  WORK_AUTHORIZATIONS,
  work_preference,
} from "../../utils/const2";
import { allWorkAuthorization } from "../../redux/common/workAuthorizationSlice";
import { allLocation } from "../../redux/common/locationSlice";
import {
  addSkill,
  allSkill,
  resetAddedSkill,
} from "../../redux/common/skillSlice";
import { FixedSizeList } from "react-window";
import ActiveBenchSalesDrawer from "./ActiveBenchSalesDrawer";
import ActiveCandidateDrawer from "./ActiveCandidateDrawer";
import { getAllMassmailHistory, getAllRecruiterCandidate } from "../../redux/massmail/massmailSlice";

const customStyle = {
  width: "100%",
  padding: "3px",
  "& .MuiInputLabel-root": { fontSize: "14px" },
};

const fieldStyles = {
  width: "100%",
  "& .MuiInputBase-root": {
    paddingLeft: "5px", // Adjust padding to make space for the icon
  },
  "& .MuiInputLabel-root": {
    left: "25px",
    fontSize: "14px ", // Adjust label position to align with input text
  },
  "& .MuiInputBase-input": {
    // paddingBottom: "7px", // Add padding to the input text itself to make space for the icon
  },
  "& .MuiInputLabel-shrink": {
    left: "25px",
    fontSize: "14px  ", // Adjust label position when it shrinks
  },
  padding: "20px",
};

const prefer_tax_term = [
  { id: "contract", name: "Contract" },
  { id: "contract_to_hire", name: "Contract To Hire" },
  { id: "full_Time", name: "Fulltime" },
  { id: "w2_with_benefit", name: "W2 Hourly Benefit" },
  { id: "w2_without_benefit", name: "W2 Hourly No Benefit" },
  { id: "1099", name: "1099" },
  { id: "working_in_all", name: "All" },
];

const renderVirtualizedList = React.forwardRef(function ListboxComponent(
  props,
  ref
) {
  const { children, ...rest } = props;

  return (
    <div ref={ref} {...rest}>
      <FixedSizeList
        height={300} // Adjust dropdown height
        width="100%"
        itemSize={46} // Height of each item
        itemCount={children.length}
      >
        {({ index, style }) =>
          React.cloneElement(children[index], {
            style: { ...style, top: `${style.top}px` },
            onMouseDown: (event) => {
              // Prevent closing on click
              event.preventDefault();
            },
          })
        }
      </FixedSizeList>
    </div>
  );
});

function JobViewMassmailDrawer({ handleClose, show, jobID }) {
  const [text, setText] = useState("");
  const [openPostIs, setOpenPostIs] = useState(false);
  const [requirementID, setRequirementID] = useState("");
  const [showAttachments, setShowAttachments] = useState(false);
  const [inputText, setInputText] = useState("");
  const [showBenchSales, setShowBenchSales] = useState(false);
  const handleCloseShowBenchSales = () => setShowBenchSales(false);
  const handleShowBenchSales = () => setShowBenchSales(true);
  const [showCandidate, setShowCandidate] = useState(false);
  const handleCloseShowCandidate = () => setShowCandidate(false);
  const handleShowCandidate = () => setShowCandidate(true);
  const theme = useTheme();
  const textareaRef = useRef(null);
  const dispatch = useDispatch();
  const locations = useSelector((state) => state.location);
  const profile = useSelector((state) => state.profile.data);
  const skillData = useSelector((state) => state.skill.data);
  const addedSkill = useSelector((state) => state.skill.addedSkill);

  const postRequirementStatus = useSelector(
    (state) => state.postrequirement.status
  );

  const requirementRecentData = useSelector(
    (state) => state.postrequirement.requirementRecentData
  );
  const massmailStatus = useSelector((state) => state.massmail.status);
  const candidateData = useSelector((state) => state.massmail.data);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // Reset the height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Adjust to scroll height
    }
  }, [text]);

  const handleAddAttachmentClick = () => {
    setShowAttachments(!showAttachments);
  };

  useEffect(() => {
    dispatch(allWorkAuthorization());
    dispatch(allLocation());
    dispatch(allSkill());
  }, [dispatch]);

  useEffect(() => {
    if (requirementRecentData) {
      setRequirementID(requirementRecentData?.requirement?.job_id);
    }
  }, [requirementRecentData]);

  const handleOnSubmitRequirement = () => {
    setOpenPostIs(false);
    formik.handleSubmit();
  };

  const formik = useFormik({
    initialValues: {
      job_title: jobID?.job_title || "",
      job_description: jobID?.job_description || "",
      experience: jobID?.experience || "",
      job_type: "full_Time",
      requirement_type: jobID?.requirement_type || [],
      duration: jobID?.duration || "",
      work_preference: jobID?.work_preference || "",
      location: jobID?.location || [],
      work_authorization: "GC",
      visa: jobID?.visa || [],
      mode_of_interview: jobID?.mode_of_interview || "",
      category: jobID?.category || "",
      job_headline: jobID?.job_headline || "",
      no_of_opening: jobID?.no_of_opening || "",
      rate: jobID?.rate || "",
      client_name: jobID?.client_name || "",
      skills: jobID?.skills || [],
    },
    validationSchema: Yup.object({
      job_title: Yup.string().required("Job Title is required"),
      job_description: Yup.string().required("Job Description is required"),
      experience: Yup.string().required("Experience is required"),
      work_preference: Yup.string().required("Work Preference is required"),
      location: Yup.array()
        .min(1, "Location is required")
        .required("Location is required"),

      requirement_type: Yup.array()
        .min(1, "Hirring Mode is required")
        .required("Hirring Mode is required"),
      visa: Yup.array()
        .min(1, "Work Authorization is required")
        .required("Work Authorization is required"),

      mode_of_interview: Yup.string().required("Mode Of Interview is required"),
      no_of_opening: Yup.string().required("Number Of Opening is required"),
      job_headline: Yup.string().required("Job Headline is required"),
    }),
    onSubmit: (values) => {},
  });

  useEffect(() => {
    if (
      postRequirementStatus === "create_requirement_post" ||
      postRequirementStatus === "update_requirement_post"
    ) {
    }
  }, [postRequirementStatus]);

  const autoResize = (textarea) => {
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  };

  const handleNoOfPosition = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 3) {
      formik.setFieldValue("no_of_opening", value);
    }
  };

  const handleChangeExperience = (e) => {
    const rawValue = e.target.value.replace(/[^0-9.]/g, "");
    if (/^\d*$/.test(rawValue) && rawValue.length <= 2) {
      formik.setFieldValue("experience", rawValue);
    }
  };

  const handleChangeDuration = (e) => {
    const rawValue = e.target.value.replace(/[^0-9.]/g, "");
    if (/^\d*$/.test(rawValue) && rawValue.length <= 2) {
      formik.setFieldValue("duration", rawValue);
    }
  };

  useEffect(() => {
    if (addedSkill?.location?.id) {
      const skillId = addedSkill?.location?.id;
      const currentSkills = formik.values.skills || [];

      if (!currentSkills.includes(skillId)) {
        // Add the new skill to Formik's field
        formik.setFieldValue("skills", [...currentSkills, skillId]);
        setInputText("");

        // ✅ Reset addedSkill in Redux to avoid re-triggering
        dispatch(resetAddedSkill());
      }
    }
  }, [addedSkill, formik, dispatch]);

  const handleAddSkill = useCallback(async () => {
    if (inputText.trim()) {
      const newSkill = inputText.trim();
      const isExistingSkill = skillData?.locations?.some(
        (skl) => skl.name.toLowerCase() === newSkill.toLowerCase()
      );

      if (!isExistingSkill) {
        await dispatch(addSkill({ name: newSkill })); // Add new skill
        dispatch(allSkill()); // Refresh skills
      }
    }
  }, [inputText, skillData, dispatch]);

  const handleClearAll = () => {
    formik.setFieldValue("skills", []); // Clear Formik field
    setInputText(""); // Clear input text

    // ✅ Reset addedSkill to prevent it from reappearing
    dispatch(resetAddedSkill());
  };

  useEffect(() => {
    if (jobID) {
      formik.setFieldValue("job_title", jobID?.job_title);
      formik.setFieldValue("job_description", jobID?.job_description);
      formik.setFieldValue("experience", jobID?.experience);
      formik.setFieldValue("requirement_type", jobID?.requirement_type);
      formik.setFieldValue("duration", jobID?.duration);
      formik.setFieldValue("work_preference", jobID?.work_preference);
      formik.setFieldValue("location", jobID?.location);
      formik.setFieldValue("visa", jobID?.visa);
      formik.setFieldValue("mode_of_interview", jobID?.mode_of_interview);
      formik.setFieldValue("category", jobID?.category);
      formik.setFieldValue("job_headline", jobID?.job_headline);
      formik.setFieldValue("no_of_opening", jobID?.no_of_opening);
      formik.setFieldValue("rate", jobID?.rate);
      formik.setFieldValue("client_name", jobID?.client_name);
      formik.setFieldValue("skills", jobID?.skills);
    }
  }, [jobID]);

  useEffect(() => {
    let jobDetails = `job_id=${jobID?.job_id}&skills=${encodeURIComponent(
      JSON.stringify(jobID.skills)
    )}`;
    dispatch(getAllRecruiterCandidate(jobDetails));
  }, [jobID]);

  const handleOnClickSendBoth = () => {
    handleShowBenchSales();
    handleCloseShowCandidate();
  };

  const handleClickOnSendCandidate = () => {
    handleShowCandidate();
    handleCloseShowBenchSales();
  };

  useEffect(() => {
    if (massmailStatus === "post_massmail_succeeded") {
      handleClose();
      handleCloseShowCandidate();
      handleShowCandidate();
      dispatch(getAllMassmailHistory(""));
    }
  }, [massmailStatus]);

  console.log({ candidateData });

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "60%",
        padding: "0 0 0 10px",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Offcanvas.Title style={{ fontWeight: "600", color: customTextColor }}>
          Active Job List
          <Typography sx={{ marginBottom: "0" }}>
            Fully transparent report will send you
          </Typography>
        </Offcanvas.Title>
        <RxCross2
          style={{
            fontSize: "22px",
            cursor: "pointer",
            color: customTextColor,
          }}
          onClick={handleClose}
        />
      </Offcanvas.Header>
      <Offcanvas.Body>
        <ThemeProvider theme={theme}>
          <form onSubmit={formik.handleSubmit}>
            <Box>
              <Grid
                container
                sx={{
                  backgroundColor: "#fff",
                  paddingBottom: "10px",
                  borderRadius: "2px",
                }}
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  sx={{ padding: "7px 15px 0" }}
                >
                  <TextField
                    label="Job Headline"
                    variant="standard"
                    name="job_headline"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.job_headline}
                    sx={customStyle}
                    InputLabelProps={{
                      sx: { marginLeft: "2px" },
                    }}
                  />
                  {formik.touched.job_headline && formik.errors.job_headline ? (
                    <div className={styles.error}>
                      {formik.errors.job_headline}
                    </div>
                  ) : null}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  sx={{ padding: "7px 15px 0" }}
                >
                  <TextField
                    label="Job Title"
                    variant="standard"
                    sx={customStyle}
                    name="job_title"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.job_title}
                    InputLabelProps={{
                      sx: { marginLeft: "2px" },
                    }}
                  />
                  {formik.touched.job_title && formik.errors.job_title ? (
                    <div className={styles.error}>
                      {formik.errors.job_title}
                    </div>
                  ) : null}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  sx={{ padding: "7px 15px 0" }}
                >
                  <TextField
                    label="Experience"
                    variant="standard"
                    type="text"
                    name="experience"
                    // onChange={formik.handleChange}
                    onChange={handleChangeExperience}
                    onBlur={formik.handleBlur}
                    // value={formik.values.experience}
                    value={
                      formik.values.experience
                        ? `${formik.values.experience} ${
                            formik.values.experience > 1 ? "Years" : "Year"
                          }`
                        : ""
                    }
                    sx={customStyle}
                    InputLabelProps={{
                      sx: { marginLeft: "2px" },
                    }}
                  />
                  {formik.touched.experience && formik.errors.experience ? (
                    <div className={styles.error}>
                      {formik.errors.experience}
                    </div>
                  ) : null}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  sx={{ padding: "7px 15px 0" }}
                >
                  <Autocomplete
                    multiple
                    id="autocomplete-multi-select"
                    options={locations?.data?.locations || []}
                    disableCloseOnSelect
                    value={
                      locations?.data?.locations?.filter((location) =>
                        formik.values.location?.includes(location.id)
                      ) || []
                    }
                    onChange={(event, value) => {
                      const selectedLocations = value?.map(
                        (location) => location?.id
                      );
                      formik.setFieldValue("location", selectedLocations);
                    }}
                    onBlur={formik.handleBlur}
                    getOptionLabel={(option) => option?.name || ""}
                    renderOption={(props, option, { selected }) => (
                      <MenuItem {...props}>
                        <Checkbox
                          checked={selected}
                          sx={{ marginRight: 0, marginLeft: 0 }}
                        />
                        <span>{option?.name}</span>{" "}
                      </MenuItem>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Location"
                        variant="standard"
                        size="small"
                        // placeholder="Prefer Location"
                        name="location"
                        sx={customStyle}
                        InputLabelProps={{
                          sx: { marginLeft: "2px" },
                        }}
                      />
                    )}
                    sx={{ backgroundColor: "#fff", width: "100%" }}
                  />

                  {formik.touched.location && formik.errors.location ? (
                    <div className={styles.error}>{formik.errors.location}</div>
                  ) : null}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  sx={{ padding: "7px 15px 0" }}
                >
                  <Autocomplete
                    multiple
                    id="autocomplete-multi-select"
                    options={prefer_tax_term || []}
                    disableCloseOnSelect
                    value={
                      prefer_tax_term?.filter((tax_term) =>
                        formik.values.requirement_type?.includes(tax_term.id)
                      ) || []
                    }
                    onChange={(event, value) => {
                      const isAllSelected = value.some(
                        (v) => v.id === "working_in_all"
                      );
                      let selectedPrefertaxterm = [];

                      if (isAllSelected) {
                        // Select all options except "All"
                        selectedPrefertaxterm = prefer_tax_term
                          .filter((option) => option.id !== "working_in_all")
                          .map((option) => option.id);
                      } else {
                        selectedPrefertaxterm = value.map(
                          (tax_term) => tax_term?.id
                        );

                        // If "All" was previously selected but now a single option is unselected
                        if (
                          formik.values.requirement_type?.includes(
                            "working_in_all"
                          ) &&
                          selectedPrefertaxterm.length <
                            prefer_tax_term.length - 1
                        ) {
                          selectedPrefertaxterm = selectedPrefertaxterm.filter(
                            (id) => id !== "working_in_all"
                          );
                        }
                      }

                      formik.setFieldValue(
                        "requirement_type",
                        selectedPrefertaxterm
                      );
                    }}
                    onBlur={formik.handleBlur}
                    getOptionLabel={(option) =>
                      option?.id === "working_in_all" ? "" : option?.name || ""
                    }
                    renderOption={(props, option, { selected }) => (
                      <MenuItem {...props}>
                        <Checkbox
                          checked={
                            formik.values.requirement_type.includes(
                              option.id
                            ) ||
                            (option.id === "working_in_all" &&
                              formik.values.requirement_type.length ===
                                prefer_tax_term.length - 1)
                          }
                          sx={{ marginRight: 0, marginLeft: 0 }}
                        />
                        <span>{option?.name}</span>
                      </MenuItem>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Mode of Hiring"
                        variant="standard"
                        size="small"
                        name="requirement_type"
                        sx={customStyle}
                        InputLabelProps={{
                          sx: { marginLeft: "2px" },
                        }}
                      />
                    )}
                    sx={{ backgroundColor: "#fff", width: "100%" }}
                  />
                  {formik.touched.requirement_type &&
                  formik.errors.requirement_type ? (
                    <div className={styles.error}>
                      {formik.errors.requirement_type}
                    </div>
                  ) : null}
                </Grid>

                {formik.values.requirement_type?.includes(
                  "full_Time"
                ) ? null : (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    lg={6}
                    sx={{ padding: "7px 15px 0" }}
                  >
                    <TextField
                      label="Duration (Optional)"
                      variant="standard"
                      name="duration"
                      onChange={handleChangeDuration}
                      onBlur={formik.handleBlur}
                      // value={formik.values.duration}
                      value={
                        formik.values.duration
                          ? `${formik.values.duration} ${
                              formik.values.duration > 1 ? "months" : "month"
                            }`
                          : ""
                      }
                      sx={customStyle}
                      InputLabelProps={{
                        sx: { marginLeft: "2px" },
                      }}
                    />
                  </Grid>
                )}
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  sx={{ padding: "7px 15px 0" }}
                >
                  <Autocomplete
                    multiple
                    id="autocomplete-multi-select"
                    options={WORK_AUTHORIZATIONS || []}
                    disableCloseOnSelect
                    value={
                      WORK_AUTHORIZATIONS?.filter((tax_term) =>
                        formik.values.visa?.includes(tax_term.id)
                      ) || []
                    }
                    onChange={(event, value) => {
                      const selectedPrefertaxterm = value?.map(
                        (tax_term) => tax_term?.id
                      );
                      formik.setFieldValue("visa", selectedPrefertaxterm);
                    }}
                    onBlur={formik.handleBlur}
                    getOptionLabel={(option) => option?.name || ""}
                    renderOption={(props, option, { selected }) => (
                      <MenuItem {...props}>
                        <Checkbox
                          checked={selected}
                          sx={{ marginRight: 0, marginLeft: 0 }}
                        />
                        <span>{option?.name}</span>{" "}
                      </MenuItem>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Work Authorization"
                        variant="standard"
                        size="small"
                        name="visa"
                        sx={customStyle}
                        InputLabelProps={{
                          sx: { marginLeft: "2px" },
                        }}
                      />
                    )}
                    sx={{ backgroundColor: "#fff", width: "100%" }}
                  />

                  {formik.touched.visa && formik.errors.visa ? (
                    <div className={styles.error}>{formik.errors.visa}</div>
                  ) : null}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  sx={{ padding: "7px 15px 0" }}
                >
                  <TextField
                    select
                    variant="standard"
                    label="Work Preference"
                    name="work_preference"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.work_preference}
                    sx={customStyle}
                    InputLabelProps={{
                      sx: { marginLeft: "2px" },
                    }}
                  >
                    {work_preference.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                  {formik.touched.work_preference &&
                  formik.errors.work_preference ? (
                    <div className={styles.error}>
                      {formik.errors.work_preference}
                    </div>
                  ) : null}
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  sx={{ padding: "7px 15px 0" }}
                >
                  <TextField
                    select
                    variant="standard"
                    label="Mode of Interview"
                    name="mode_of_interview"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.mode_of_interview}
                    sx={customStyle}
                    InputLabelProps={{
                      sx: { marginLeft: "2px" },
                    }}
                  >
                    {mode_of_interview.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                  {formik.touched.mode_of_interview &&
                  formik.errors.mode_of_interview ? (
                    <div className={styles.error}>
                      {formik.errors.mode_of_interview}
                    </div>
                  ) : null}
                </Grid>

                {/* {formik.values.requirement_type?.includes("full_Time") &&
            formik.values.requirement_type?.length > 1 ? (
              ""
            ) : ( */}
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  sx={{ padding: "7px 15px 0" }}
                >
                  <TextField
                    label={
                      formik.values.requirement_type?.includes("full_Time")
                        ? "Salary (Optional)"
                        : "Rate (Optional)"
                    }
                    variant="standard"
                    name="rate"
                    type="text"
                    // onChange={formik.handleChange}
                    onChange={(e) => {
                      const rawValue = e.target.value.replace(/[^0-9.]/g, ""); // Keep only numeric input
                      // formik.setFieldValue("rate", rawValue);
                      if (rawValue.length <= 3) {
                        formik.setFieldValue("rate", rawValue); // Set value only if length <= 3
                      }
                    }}
                    onBlur={formik.handleBlur}
                    // value={formik.values.rate}
                    value={
                      formik.values.rate
                        ? `$${formik.values.rate} ${
                            formik.values.requirement_type?.includes(
                              "full_Time"
                            )
                              ? "Yearly"
                              : "Hourly"
                          }`
                        : ""
                    }
                    sx={customStyle}
                    InputLabelProps={{
                      sx: { marginLeft: "2px" },
                    }}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  sx={{ padding: "7px 15px 0" }}
                >
                  <TextField
                    label="Client (Optional)"
                    variant="standard"
                    sx={customStyle}
                    name="client_name"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.client_name}
                    InputLabelProps={{
                      sx: { marginLeft: "2px" },
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  sx={{ padding: "7px 15px 0" }}
                >
                  <TextField
                    label="No of Position Opening"
                    variant="standard"
                    name="no_of_opening"
                    type="number"
                    onChange={handleNoOfPosition}
                    onBlur={formik.handleBlur}
                    value={formik.values.no_of_opening}
                    sx={customStyle}
                    InputLabelProps={{
                      sx: { marginLeft: "2px" },
                    }}
                  />
                  {formik.touched.no_of_opening &&
                  formik.errors.no_of_opening ? (
                    <div className={styles.error}>
                      {formik.errors.no_of_opening}
                    </div>
                  ) : null}
                </Grid>
              </Grid>

              <Box
                className={styles.mandatory_description}
                sx={{ margin: "14px 0" }}
              >
                <Box sx={{ color: customTextColor }}>
                  {/* <Typography sx={{ padding: '0 5px 30px 0' }}>Job description</Typography> */}
                  <textarea
                    class="form-control"
                    id="exampleFormControlTextarea1"
                    rows="5"
                    placeholder="Job description"
                    name="job_description"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.job_description}
                    onInput={(event) => autoResize(event.target)}
                    ref={(el) => el && autoResize(el)}
                    style={{
                      overflow: "hidden",
                      resize: "none",
                      border: "none",
                    }}
                  ></textarea>
                  <hr style={{ marginBottom: "0" }}></hr>
                  {/* <Typography >Mandatory Skills</Typography> */}
                  {/* <textarea
                class="form-control"
                name="skills"
                id="exampleFormControlTextarea1"
                rows="3"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.skills}
                placeholder="Mandatory Skills"
                onInput={(event) => autoResize(event.target)}
                ref={(el) => el && autoResize(el)}
                style={{ overflow: "hidden", resize: "none", border: "none" }}
              ></textarea> */}
                </Box>
                {formik.touched.job_description &&
                formik.errors.job_description ? (
                  <div className={styles.error} style={{ border: "none" }}>
                    {formik.errors.job_description}
                  </div>
                ) : null}
              </Box>

              <Box>
                <Autocomplete
                  multiple
                  id="autocomplete-multi-select"
                  options={skillData?.locations || []}
                  disableCloseOnSelect
                  value={
                    skillData?.locations?.filter((skl) =>
                      formik.values.skills?.includes(skl.id)
                    ) || []
                  }
                  onChange={(event, value) => {
                    const selectedLocations = value?.map((skl) => skl?.id);
                    formik.setFieldValue("skills", selectedLocations);

                    // ✅ Reset addedSkill when manually removing skills
                    if (selectedLocations.length === 0) {
                      handleClearAll(); // Call clear all method
                    } else {
                      dispatch(resetAddedSkill());
                    }
                  }}
                  onBlur={formik.handleBlur}
                  getOptionLabel={(option) => option?.name || ""}
                  inputValue={inputText}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason !== "reset") {
                      setInputText(newInputValue);
                    }
                  }}
                  renderOption={(props, option, { selected }) => (
                    <MenuItem {...props}>
                      <Checkbox
                        checked={selected}
                        sx={{ marginRight: 0, marginLeft: 0 }}
                      />
                      <span>{option?.name}</span>
                    </MenuItem>
                  )}
                  ListboxComponent={renderVirtualizedList} // Use virtualized list
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Mandatory Skills"
                      variant="standard"
                      size="small"
                      name="skills"
                      sx={fieldStyles}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleAddSkill();
                        }
                      }}
                    />
                  )}
                  sx={{ backgroundColor: "#fff", width: "100%" }}
                />
              </Box>
              <div
                style={{
                  backgroundColor: "#fff",
                  padding: "0 15px 0 ",
                  margin: "14px 0",
                  marginBottom: "40px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#fff",
                    padding: "5px 10px 5px 10px",
                  }}
                >
                  <Box className={styles.recruiter_profile}>
                    <div>
                      <img src={profile?.profile?.profile_picture} alt="" />
                      <span style={{ color: customTextColor }}>
                        <Typography>
                          <b>{profile?.profile?.full_name}</b>
                        </Typography>
                        <Typography>
                          <b>
                            {profile?.profile?.designation} –{" "}
                            {profile?.profile?.company_name}
                          </b>
                        </Typography>
                        <Typography sx={{ marginBottom: "10px !important" }}>
                          Ph: {profile?.profile?.mobile_no} | E-Mail:
                          {profile?.profile?.email}
                        </Typography>
                      </span>
                    </div>
                  </Box>
                </div>
              </div>
            </Box>
          </form>
        </ThemeProvider>
        <Box className={styles.send_update_btns}>
          <button onClick={handleClickOnSendCandidate}>
            Send to Candidate
          </button>

          {formik.values.requirement_type?.includes("full_Time") &&
          formik.values.requirement_type?.length === 1 ? (
            ""
          ) : (
            <button
              style={{ backgroundColor: "#3856a6" }}
              onClick={handleOnClickSendBoth}
            >
              Send to Both
            </button>
          )}
        </Box>
      </Offcanvas.Body>
      <ActiveBenchSalesDrawer
        handleShow={handleShowBenchSales}
        handleClose={handleCloseShowBenchSales}
        show={showBenchSales}
        jobID={jobID}
        valueData={formik.values}
        candidateData={candidateData}
      />
      <ActiveCandidateDrawer
        handleShow={handleShowCandidate}
        handleClose={handleCloseShowCandidate}
        show={showCandidate}
        jobID={jobID}
        valueData={formik.values}
        candidateData={candidateData}
      />
    </Offcanvas>
  );
}

export default JobViewMassmailDrawer;
